













import { Component, Vue } from 'vue-property-decorator';
import { Power4, TweenLite } from 'gsap';
import Spinner from '@/components/ui/Spinner.vue';
import Logo from '@/components/ui/Logo.vue';

@Component({
  components: {
    Spinner,
    Logo,
  },
})
export default class Preloader extends Vue {

  private get isVisible(): boolean {
    return this.$store.state.ui.loader;
  }

  private get delay(): number {
    return this.$store.state.ui.delay;
  }

  private show(): void {
    this.$store.commit('ui/setLoader', true);
    TweenLite.to(this.$refs.loader, 0.6, { autoAlpha: 1, ease: Power4.easeOut });
  }

  private hide(): void {

    TweenLite.to(this.$refs.loader, 0.6, {
      autoAlpha: 0,
      ease: Power4.easeIn,
      delay: this.delay,
      onComplete: () => {
        this.$store.commit('ui/setLoader', false);
        if (this.delay) {
          this.$store.commit('ui/setDelay', 0);
        }
      },
    });
  }

  private mounted(): void {
    this.$bus.$on('progress-delay', this.setDelay);
    this.$bus.$on('progress-start', this.show);
    this.$bus.$on('progress-stop', this.hide);
  }

  private setDelay(delay: number) {
    this.$store.commit('ui/setDelay', delay);
  }
}
